import { CVCPayload } from "./types";
import { fetchAPI2 } from "../fetchAPI2";
import { simulateApiError } from "../errors";

export const _submitCVC = async (payload: CVCPayload) => {

  // await simulateApiError({path: "/cvc"});

  const data = await fetchAPI2<{ ID: string }, CVCPayload>("/cvc", {
    method: "POST",
    body: payload,
    unauthenticated: true,
  });

  return data;
};
